import axios from 'axios';
import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';
import { DeviceTypeCodes } from '@/features/devices/schemas/devices.schemas.ts';

type TDevice = {
  unit: string;
  fieldCode: number;
  deviceTypeCode: DeviceTypeCodes;
  aggregation: string;
  time: string;
  value: number;
  last24Hours: TDevice[];
};

export type TDeviceOverviewConfig = {
  fields: number[];
};

export type TOverviewDevice = {
  device: TDevice[];
  plant: {
    name: string;
    country: string;
    state: string;
    city: string;
  };
  config: TDeviceOverviewConfig;
};

export async function getOverviewDevice({
  deviceId,
}: {
  deviceId: string;
}): Promise<TOverviewDevice | undefined | never> {
  try {
    const { data } = await client.get(`/devices/${deviceId}/overview`);

    return data?.body;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}}`);
    }
  }
}

export const useOverviewDeviceQuery = ({ deviceId }: { deviceId: string }) => {
  return useQuery({
    queryKey: ['device', deviceId, 'overview'],
    queryFn: () => getOverviewDevice({ deviceId }),
    retry: 1,
    staleTime: 1000 * 60,
  });
};
